// AUTO-GENERATED by scripts/generate-hero-overrides.mjs — do not edit by hand.
// Seed values for the admin-managed hero overrides so the correct hero image is
// painted on first render (no bundled-image → override swap flash).

export interface HeroOverrideSeed {
  url: string;
  alt: string | null;
}

export const GUIDE_HERO_OVERRIDES: Record<string, HeroOverrideSeed> = {
  "mission-beach-boardwalk": {
    "url": "https://ljbyvcsgucdurkvvksfx.supabase.co/storage/v1/object/public/site-images/guides/ai-mission-beach-boardwalk-1783798018245.png",
    "alt": null
  },
  "best-beaches-in-san-diego": {
    "url": "https://ljbyvcsgucdurkvvksfx.supabase.co/storage/v1/object/public/site-images/guides/ai-best-beaches-in-san-diego-1783359016218.png",
    "alt": null
  },
  "beach-camping-san-diego": {
    "url": "https://ljbyvcsgucdurkvvksfx.supabase.co/storage/v1/object/public/site-images/guides/ai-beach-camping-san-diego-1784177600177.png",
    "alt": null
  },
  "san-diego-beach-rules-first-timers": {
    "url": "/images/guides/san-diego-beach-rules-first-timers.jpg",
    "alt": "Family reading posted beach rules near a lifeguard tower on a sunny San Diego beach"
  },
  "best-free-things-to-do-san-diego-coast": {
    "url": "/images/guides/best-free-things-to-do-san-diego-coast.jpg",
    "alt": "Hikers on a San Diego coastal bluff trail above the Pacific Ocean"
  },
  "san-diego-coastal-itinerary-3-days": {
    "url": "/images/guides/san-diego-coastal-itinerary-3-days.jpg",
    "alt": "Car driving along the scenic North County coastal highway at golden hour"
  },
  "fall-san-diego-coast": {
    "url": "/images/guides/fall-san-diego-coast.jpg",
    "alt": "A quiet San Diego beach in autumn with golden light and gentle waves"
  },
  "coastal-photography-san-diego": {
    "url": "/images/guides/coastal-photography-san-diego.jpg",
    "alt": "Photographer with tripod silhouetted against a colorful sunset over the Pacific Ocean"
  },
  "mission-bay-kayak-route": {
    "url": "/images/guides/mission-bay-kayak-route.jpg",
    "alt": "Kayaker paddling on calm Mission Bay water with the San Diego skyline in the distance"
  },
  "san-diego-vs-la-beaches": {
    "url": "/images/guides/san-diego-vs-la-beaches.jpg",
    "alt": "Aerial view comparing a busy Los Angeles beach and a relaxed San Diego beach split by a coastal highway"
  },
  "san-diego-coastal-weather-microclimates": {
    "url": "/images/guides/san-diego-coastal-weather-microclimates.jpg",
    "alt": "Foggy marine layer rolling over a San Diego beach while surfers wait for waves"
  },
  "coastal-running-san-diego": {
    "url": "/images/guides/coastal-running-san-diego.jpg",
    "alt": "Runner on a coastal bluff trail with the Pacific Ocean in the background"
  }
};

export const STORY_HERO_OVERRIDES: Record<string, HeroOverrideSeed> = {
  "july-snorkeling": {
    "url": "https://ljbyvcsgucdurkvvksfx.supabase.co/storage/v1/object/public/site-images/guides/ai-july-snorkeling-1783791056856.png",
    "alt": "Snorkeler in clear blue water above a kelp forest off La Jolla, San Diego"
  },
  "march-bluff-blooms": {
    "url": "https://ljbyvcsgucdurkvvksfx.supabase.co/storage/v1/object/public/site-images/happening/march-bluff-blooms-hero.jpg",
    "alt": "Green coastal bluffs and a narrow trail above the Pacific Ocean at Torrey Pines in March"
  },
  "spring-coast-walks": {
    "url": "https://ljbyvcsgucdurkvvksfx.supabase.co/storage/v1/object/public/site-images/happening/trail-coast-walk.webp",
    "alt": "Bluff-top coastal walking path above the Pacific Ocean in La Jolla on a clear spring day"
  },
  "harbor-seal-pupping": {
    "url": "https://ljbyvcsgucdurkvvksfx.supabase.co/storage/v1/object/public/site-images/happening/seal-pupping.jpg",
    "alt": "Harbor seals and newborn pups resting on the sand at Children's Pool in La Jolla"
  },
  "august-warm-water": {
    "url": "https://ljbyvcsgucdurkvvksfx.supabase.co/storage/v1/object/public/site-images/happening/activity-paddleboard.webp",
    "alt": "Paddleboarder gliding across calm warm water on a clear San Diego summer morning"
  },
  "september-local-summer": {
    "url": "https://ljbyvcsgucdurkvvksfx.supabase.co/storage/v1/object/public/site-images/happening/september-local-summer-hero.jpg",
    "alt": "Wide, nearly empty San Diego beach with warm late-summer light in September"
  },
  "september-harbor-evenings": {
    "url": "https://ljbyvcsgucdurkvvksfx.supabase.co/storage/v1/object/public/site-images/happening/september-harbor-evenings-hero.jpg",
    "alt": "San Diego Bay and downtown skyline glowing at golden hour with a ferry crossing"
  },
  "october-fall-sunsets": {
    "url": "https://ljbyvcsgucdurkvvksfx.supabase.co/storage/v1/object/public/site-images/happening/beach-sunset-cliffs.webp",
    "alt": "Sunset Cliffs sandstone glowing orange above the Pacific Ocean at sunset in October"
  },
  "november-coastal-hikes": {
    "url": "https://ljbyvcsgucdurkvvksfx.supabase.co/storage/v1/object/public/site-images/happening/trail-torrey-pines.webp",
    "alt": "Torrey Pines coastal trail with sandstone bluffs and Pacific Ocean views on a cool clear day"
  },
  "december-holiday-coast": {
    "url": "https://ljbyvcsgucdurkvvksfx.supabase.co/storage/v1/object/public/site-images/happening/december-holiday-coast-hero.jpg",
    "alt": "Coronado shoreline at twilight in December with warm holiday lights along the waterfront"
  }
};
